

const INITIAL_STATE ={

    modelstate:[]
}

const  modelreducer = (state=INITIAL_STATE,action) =>{

  switch (action.type) {
            case 'MODEL_DROPDOWN':
          return {...state, modelstate:action.payload}
      default:
          return state;
  }
};

export default modelreducer;